import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	pageHeader: {
		id: 'admin-pages-issue-type-screen-schemes-page.page-header',
		defaultMessage: 'Issue Type Screen Schemes',
		description: 'Header of IssueType Screen Schemes Page',
	},
	addIssueTypeScreenScheme: {
		id: 'admin-pages-issue-type-screen-schemes-page.add-issue-type-screen-scheme',
		defaultMessage: 'Add issue type screen scheme',
		description: 'Add issue type screen scheme button text',
	},
	errorHeader: {
		id: 'admin-pages-issue-type-screen-schemes-page.error-header',
		defaultMessage: 'An error occurred',
		description: 'Empty state message header',
	},
	errorDescription: {
		id: 'admin-pages-issue-type-screen-schemes-page.error-description',
		defaultMessage: 'There was a problem loading your issue type screen schemes.',
		description: 'Error state message description',
	},
});
